import { Box, Grid } from "@mui/material";
import { Button, Input } from "../../../common/FormComponents";
import defaultStyles, { StylesClasses } from "./styles";
import { getStyles } from "src/styles/theme";
import { useForm } from "react-hook-form";
import errorMessage from "src/constants/errorMessage";
import { useMutation } from "react-query";
import { AxiosResponse } from "axios";
import {
  addMointoringMember,
  updateMointoringMember,
} from "src/utils/api/dashboard";
import { useAppSelector } from "src/redux/store";

export function MonitoringMember({
  landOwnershipEpid,
  selfState,
  refetch,
  /**
   * When supplied the form edits that existing member instead of adding a new
   * one. Only the four correctable fields are sent; `type` stays as it was,
   * since the API rejects reclassifying a member.
   */
  member,
}: any) {
  const styles = getStyles<StylesClasses>(defaultStyles);

  const isEditMode = Boolean(member?.id);

  const user = useAppSelector((state) => state.root.user);
  const { mutate, isLoading } = useMutation(
    "postUpdatedCostEstimateData",
    ({ updateValue }: { updateValue: any }) =>
      isEditMode
        ? updateMointoringMember(member.id, updateValue)
        : addMointoringMember(updateValue),
    {
      onSuccess: (res: AxiosResponse) => {
        console.log("data updated successfully");
        selfState(false);
        refetch();
      },
      onError: (error: any) => {
        console.log("error occured while updating");
      },
    }
  );

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    mode: "onChange",
    defaultValues: {
      name: member?.name ?? "",
      email: member?.email ?? "",
      designation: member?.designation ?? "",
      phoneNumber: member?.phoneNumber ?? "",
    },
  });

  const moniteringMemberType =
    user.data.userType === null ? "ACF" : "ENTITY_REPRESENTATIVE";
  const onSubmit = (data: any) => {
    const { name, email, designation, phoneNumber } = data;

    if (isEditMode) {
      mutate({
        updateValue: { name, email, designation, phoneNumber },
      });
      return;
    }

    mutate({
      updateValue: {
        name,
        email,
        designation,
        phoneNumber,
        type: moniteringMemberType, // edit this as per logined type
        landOwnershipEpid: landOwnershipEpid,
      },
    });
  };

  return (
    <Box {...styles("wrapper")}>
      {(user?.data?.userType === null ||
        user?.data?.userType === "ORGANIZATION") && (
        <Box
          {...styles("formWrapper")}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box {...styles("heading")}>
            {isEditMode
              ? "Update Monitoring Committe Member"
              : "Add Monitoring Committe Member"}{" "}
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Input
                customStyles={{
                  label: defaultStyles.label,
                  wrapper: defaultStyles.selectWrapper,
                  input: {
                    borderColor: "#36B1A0;",
                    boxShadow: "unset",
                  },
                }}
                name="name"
                rules={{ required: errorMessage.required }}
                control={control}
                errors={errors}
                placeholder="Enter Name"
                label="Enter Name"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                customStyles={{
                  label: defaultStyles.label,
                  wrapper: defaultStyles.selectWrapper,
                  input: {
                    borderColor: "#36B1A0;",
                    boxShadow: "unset",
                  },
                }}
                name="email"
                rules={{ required: errorMessage.required }}
                control={control}
                errors={errors}
                placeholder="Enter Email"
                label=" Enter Email"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                customStyles={{
                  label: defaultStyles.label,
                  wrapper: defaultStyles.selectWrapper,
                  input: {
                    borderColor: "#36B1A0;",
                    boxShadow: "unset",
                  },
                }}
                name="designation"
                rules={{ required: errorMessage.required }}
                control={control}
                errors={errors}
                placeholder="Enter Designation"
                label="Enter Designation"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                customStyles={{
                  label: defaultStyles.label,
                  wrapper: defaultStyles.selectWrapper,
                  input: {
                    borderColor: "#36B1A0;",
                    boxShadow: "unset",
                  },
                }}
                name="phoneNumber"
                rules={{ required: errorMessage.required }}
                control={control}
                errors={errors}
                placeholder="Enter Phone Number"
                label="Enter Phone Number"
              />
            </Grid>
          </Grid>
          <Box>
            <Button
              text={isEditMode ? "Update Member" : "Add Member"}
              type="submit"
              loading={isLoading}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
